import React from 'react'
import classNames from 'classnames'
import { FormattedNumber } from 'react-intl'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface Props extends TypographyProps {
  value?: number
  withPrefix?: boolean
  currencyStyle?: React.CSSProperties
  currencyClassName?: string
}

const styles = createStyles({
  currency: {
    opacity: .5,
    fontSize: '.6em',
    marginLeft: '.2em',
    fontFamily: '"SFPro", "Helvetica", "Arial", sans-serif',
    fontWeight: 'inherit',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const Coin: React.SFC<InjectedProps> = ({
  value,
  classes,
  withPrefix,
  currencyStyle,
  currencyClassName,
  ...props
}) => {
  return (
    <Typography noWrap {...props}>
      <FormattedNumber value={value || 0}>
        {(text: string) => (
          <Grid component="span" direction="row" alignItems="center" wrap="nowrap" container>
            <Grid component="span" item>{withPrefix ? ((value || 0) > 0 ? `+${text}` : text) : text}</Grid>
            <Grid
              className={classNames(currencyClassName, classes.currency)}
              style={currencyStyle}
              component="span"
              children="₭"
              item
            />
          </Grid>
        )}
      </FormattedNumber>
    </Typography>
  )
}

Coin.defaultProps = {
  value: 0,
}

export default withStyles(styles)(Coin)
